<template>
    <div :class="'activity-box no-min-height d-flex align-items-center ' + [isDisable ? 'disabled' : '']">
        <input type="checkbox" :name="media.media" :id="media.media" :checked="media.status" :disabled="isDisable" @change="changeStatus()" />
        <label :for="media.media" v-text="mediaLabel"></label>
    </div>
</template>

<script>

export default {
    props: ['media', 'mediaLabel', 'isDisable'],
    methods: {
        changeStatus() {
            let currentMedia = this.media;
            currentMedia.status = !currentMedia.status;

            const mediaStatusIndex = this.$store.state.mediaStatus.findIndex( function(media) {
                return media.media == currentMedia.media
            });

            this.$store.dispatch('changeMediaStatusSettings', {
                index: mediaStatusIndex,
                value: currentMedia
            })
        }
    }
}
</script>